/** @jsxRuntime classic */
/* @jsx jsx */
import { jsx } from "@emotion/react";
import facepaint from "facepaint";

// RESPONSIVENESS SETTINGS
const breakpoints = [800, 1100];
const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`));

export default function About(props) {
  return (
    <div ref={props.aboutRef} css={aboutStyle}>
      <div className="wrapper">
        <p>ABOUT</p>
        <p>
          <span className="accent">Teana</span>, banda nacida el año 2017, con
          dos EP a sus espaldas (“Lucid Fauna”, 2017; “Kill Your Ego”, 2022), y
          numerosos conciertos que los han llevado a participar en distintos
          festivales (Barcelona Psych Fest y Zaragoza Psych Fest) nos presenta
          ahora su primer LP, <span className="accent">Sagrada Bendición</span>{" "}
          (2025), un álbum que transita entre varios géneros, desde el{" "}
          <span className="accent">shoegaze</span>y el{" "}
          <span className="accent">dream pop</span> hasta la{" "}
          <span className="accent">neo-psicodelia</span>.
        </p>
        <p>
          Con un enfoque completamente autoproducido,{" "}
          <span className="accent">Sagrada Bendición</span> refleja una
          evolución sonora y emocional en la trayectoria del grupo, apostando
          por un sonido íntimo, envolvente y profundamente honesto. Una obra
          introspectiva que explora la dualidad entre el ego y la identidad, la
          adaptación social y la autenticidad personal.
        </p>
        <p>
          <span className="accent">TEANA</span> son{" "}
          <span className="accent">FABIO NUMBELA</span> (Guitarra, voz){" "}
          <span className="accent">ALEX RUIZ</span> (Guitarra, voz),
          <span className="accent">ALEXANDRE GOFAS</span> (Bajo, coros) y{" "}
          <span className="accent">FERRAN ALEMANY</span> (Batería)
        </p>
      </div>
    </div>
  );
}

const aboutStyle = mq({
  height: "100vh",
  borderBottom: "1px solid white",
  display: "flex",
  alignItems: "center",
  ".wrapper": {
    margin: "0 auto 0",
    width: ["85%", "75%", "50%"],
    textAlign: "center",
    textTransform: "uppercase",
    p: {
      marginBottom: "1.5rem",
    },
  },
  a: {
    color: "#95E888",
  },
});
